import controller from './distant-sales-dialog.controller';

export default {
  controller,
  template: require('./distant-sales-dialog.html')
};



// WEBPACK FOOTER //
// src/app/no-auth/components/distant-sales-dialog/distant-sales-dialog.component.ts